import LayoutResult from './LayoutResult';
export default LayoutResult;
